export default defineNuxtPlugin(() => {
  return {
    provide: {
      ads: {
        // 保留上游注入接口，但不再请求 Carbon Ads 的探测脚本。
        adBlocked: ref(false)
      }
    }
  }
})
